// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1bUNz","signatureButtonsRight":"ModalSign_signatureButtonsRight__1F0LD"};